import { render, staticRenderFns } from "./ContentAddTagDlg.vue?vue&type=template&id=5509a6df&scoped=true"
import script from "./ContentAddTagDlg.ts?vue&type=script&lang=ts&external"
export * from "./ContentAddTagDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509a6df",
  null
  
)

export default component.exports